import './ec-area.css';

let axisColor = '#00656b';
let textColor = '#018991';

if (window._screenType === '2160') {
    axisColor = '#154287';
    textColor = '#154287';
}

let ecAreaChart = ({ echarts, dom, data }) => {
    // 数据处理与准备
    let duration = 1000;
    data.dateArr = data.date.map((item, index) => {
        let year = item.slice(0, 4);
        let week = item.slice(4, 6);

        let isFirst = index === 0;
        let isLast = index === data.date.length - 1;
        let space = ' '.repeat(15);
        let str = `${year}.week${week}`;
        if (isFirst) {
            return space + str;
        }
        if (isLast) {
            return str + space;
        }
        return str;
    });

    // 销毁事件
    ecAreaChart.destroy = () => {
        echarts.dispose(dom);
        window.removeEventListener('resize', resizeChartArea);
    };

    let myChart = echarts.init(dom);
    function resizeChartArea() {
        if (myChart) {
            myChart.resize();
        }
    }
    window.addEventListener('resize', resizeChartArea);
    let scale = window._scale || 1;
    // if (window._screenType === '2160') {
    //     scale = 2;
    // }
    // 指定图表的配置项和数据
    let option = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                label: {
                    backgroundColor: '#6a7985'
                }
            },
            textStyle: {
                fontSize: scale * 14
            },
            formatter: (params, ticket) => {
                let label = params[0].axisValueLabel;
                // label = label.replace('W.', '第') + '周';
                let tpl = label + '<br/>';
                params.forEach(item => {
                    tpl += `${item.seriesName}: ${item.data}<br/>`;
                });
                return tpl;
            }
        },
        grid: {
            top: 15,
            left: 20,
            right: 40,
            bottom: 0,
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: data.dateArr,
            axisLabel: {
                color: textColor,
                interval: data.dateArr.length - 2, // 只显示头和尾，可将间隔设置为data.length - 2
                margin: 3,
                fontSize: scale * 12
            },
            axisLine: {
                lineStyle: {
                    color: axisColor,
                    width: 2,
                },
            },
            axisTick: {
                show: false,
                lineStyle: {
                    color: '#31478C',
                    width: 2,
                },
            },
            nameTextStyle: {
                color: '#fff',
            }
        },
        yAxis: {
            interval: 100,
            type: 'value',
            axisLabel: {
                color: textColor,
                margin: 3,
                verticalAlign: 'middle',
                fontSize: scale * 12
            },
            splitLine: {
                show: false,
            },
            axisLine: {
                lineStyle: {
                    color: axisColor,
                    width: 2,
                },
            },
            axisTick: {
                show: false,
                lineStyle: {
                    color: '#006F76',
                    width: 2,
                },
            },
        },
        series: [{
            name: data.tip,
            data: data.count,
            type: 'line',
            animationDuration: duration,
            areaStyle: {
                color: 'rgba(31,145,169,.3)'
            },
            lineStyle: {
                color: '#19889D',
                width: '2'
            },
            itemStyle: {
                opacity: 0,
            },
        }]
    };
    if (window._screenType === '2160') {
        option.series[0].areaStyle.color = '#062957';
        option.series[0].lineStyle.color = '#0878c4';
        option.series[0].lineStyle.width = '6';
        option.xAxis.axisLine.lineStyle.width = 4;
        option.xAxis.axisTick.lineStyle.width = 4;
        option.yAxis.axisLine.lineStyle.width = 4;
        option.yAxis.axisTick.lineStyle.width = 4;
        option.grid.top = 30;
    }
    myChart.setOption(option);
    return ecAreaChart;
};

export default ecAreaChart;
